module.exports = __webpack_public_path__ + "img/admin.9cfbe4e1.svg";